import React, { useState } from "react";
import Select from "react-select";
import { customMapper, selectOnChangeWrapper } from "utils/select";
import { getAccount } from "containers/Accounts/reducer";
import { getDataset, getDatasetsArr } from "containers/Home/reducer";
import * as RelationUtils from "utils/relation";
import styles from "./style.module.css";
import { RelationLineageItem } from "./RelationLineage";
import { getBaseDraft } from "containers/Relation/reducer";
import { useSelector } from "types/store";
const DATASET_MAPPER = customMapper((d) => `(${d.id}) ${d.name}`);
const ReplayInput = ({ relation, onChange, isDisabled }) => {
    const tag = RelationUtils.getLatestTag(relation);
    const datasetId = tag?.dataset_id;
    const dataset = useSelector((state) => getDataset(state, datasetId));
    const account = useSelector((state) => getAccount(state, dataset.account_id));
    const datasets = useSelector((state) => getDatasetsArr(state));
    const baseRelation = useSelector((state) => (datasetId === undefined ? relation : getBaseDraft(state, datasetId)));
    const [replayTarget, updateReplayTarget] = useState(undefined);
    const accountLabel = account?.name ?? `Account Id: ${dataset.account_id}`;
    const currentContext = RelationUtils.getOutputContext(baseRelation);
    const validDatasets = datasets.filter((d) => d.id != dataset.id &&
        d.account_id == dataset.account_id &&
        d.folder_id == dataset.folder_id &&
        d.transformations.plan?.relation !== undefined &&
        d.transformations.plan.relation.type !== "DATA_SOURCE" &&
        RelationUtils.getSources(RelationUtils.fromDataset(d)).some((r) => {
            const update = RelationUtils.contextFromSchemaItems(r.content.schema);
            return Object.entries(update).every(([key, output]) => currentContext[key]?.type == output.type);
        }));
    const idUpdateMap = validDatasets.reduce((map, dataset) => {
        map[dataset.id] = RelationUtils.toComposableList(RelationUtils.fromDataset(dataset));
        return map;
    }, {});
    return (React.createElement("div", { className: styles.replayTransform },
        React.createElement("div", { style: { fontWeight: "bold", color: "#4b495b" } }, "Select Dataset"),
        React.createElement(Select, { options: DATASET_MAPPER.mapAll(validDatasets), value: DATASET_MAPPER.map(replayTarget), onChange: selectOnChangeWrapper((d) => {
                updateReplayTarget(d);
                if (d !== undefined) {
                    const builder = RelationUtils.builder(baseRelation);
                    const update = idUpdateMap[d.id].reduce((b, update) => b.cherryPick(update), builder).build();
                    if (update.type != "DATA_SOURCE") {
                        onChange(update);
                    }
                }
            }), placeholder: `Search or Select a Dataset Stored in ${accountLabel}`, isDisabled: isDisabled }),
        replayTarget !== undefined && (React.createElement(React.Fragment, null,
            React.createElement("div", { style: { marginTop: "30px" } }, (idUpdateMap[replayTarget.id] ?? [])
                .slice()
                .reverse()
                .map((r, i) => (React.createElement(RelationLineageItem, { key: i, relation: r, readOnly: true }))))))));
};
export default ReplayInput;
